<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.27
        <br>2020
      </span>
      <span class="tiel">【光明日报】美菜全力保障武汉抗疫一线物资供应</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        据国家卫健委通报，截至1月27日12时，全国累计报告新型冠状病毒感染的肺炎确诊病例2784例，其中死亡81例，已治愈出院53例。疫情爆发以来，美菜武汉员工克服各种困难，坚持“不打烊服务”，为武汉市提供食材配送保障，切实肩负起企业的使命担当。据不完全统计，目前有包括华中科技大学附属协和医院、武大人民医院、黄石市中心医院、大治市中心医院等多家医疗机构通过美菜保障一线疫情防控人员的饮食需求。
        <br>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/b0309_9.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">物资紧急装车</div>
      <div class="tet-js">
        <p>目前美菜正在紧急调配更多的物资，并开始针对家庭和个人配送食材，保障武汉市民的基本饮食需求。同时，从1月27日起，美菜将开辟绿色通道，优先为湖北的医院、驻军部队、防疫保障单位、防疫指挥机构等防疫一线部门提供食材配送。</p>
        <br>
        <br>
        <p>据悉，黄石市中心医院已协调当地政府，为美菜配送车辆办理疫情期间特别通行证，可凭此走高速的特别通道，减少路途时间。</p>
        <br>
        <div class="tet-js" style="text-align: center">（光明日报全媒体记者王子墨）</div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
